<div class="static-container">
  <h4>
    Privacy and Policy
  </h4>

  <div class="mb-5">
    <p class="gray-text">
      This Privacy Policy describes the kinds of information that DML (“we”) may collect about you through
      <a  routerLink="/">www.Djmixinglab.com</a> (the “Website”) and what we may do with that information.
      We
      reserve the right to modify this Policy at any time by posting the updated version. Therefore, please check this
      page for updates whenever you visit our Website, and we may also elect to notify our registered users of
      material
      changes via e-mail or other means. This Policy does not apply to information that may be collected off-line.
    </p>
    <p class="gray-text">
      By visiting or registering at the Website, you acknowledge that you have read, understand and agree to be bound
      by
      this Policy as it may be amended from time to time, and to our collection, transfer (if applicable), storage and
      processing of your information in the United States of America. If you do not agree to these terms, you cannot
      register, make any purchases or provide us with any personal information about you on the Website.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Collection of Information</strong>
    </p>
    <p class="gray-text">
      We generally collect two kinds of information through the Website: “personal information” about you which you
      provide to us, and “non-personal information” about you, your computer and technology, and your use of the
      Website,
      which alone doesn’t identify you personally.
    </p>
    <p class="gray-text">
      In order for you to become a registered user, make purchases from, or sell content through our Website, you will
      need to provide us with certain personal information, such as your age, name, business name if applicable,
      e-mail
      address, street address and telephone number during the registration process. For online purchases or sales, we
      will
      also require your credit card number, expiration date, billing address and related details (which may include
      your
      social security or other tax ID number) in order to process payments. We may also ask for additional personal
      information from time to time such as such as gender and income level, in connection with online promotions,
      contests, giveaways, surveys and other programs, but it’s entirely up to you whether or not to provide that
      information to participate in those programs.
    </p>
    <p class="gray-text">
      We may also collect non-personal information from visitors and registered users of the Website. We may ask you
      to
      provide some of that information yourself, such as your musical preferences, your favorite artists, labels or
      genres, or your purchasing, listening and concert-going habits. Other technical, geographic and usage data and
      information we may collect directly, such as your browser type, ISP, operating system, log and Website usage
      data,
      IP address, zip code or location, the pages you visit and music or other content that you listen to or access
      while
      on the Website, websites you’ve visited upon entering or leaving the Website, and if you purchase or sell
      content
      through the Website we will keep track of those purchases and/or sales. Such information may be combined with
      your
      personal information.
    </p>
    <p class="gray-text">
      If you contact or communicate with us or our representatives by e-mail or through the Website, or if you post
      any
      information on any forums, chat rooms, profile pages, feedback, customer service or other portions of the
      Website,
      we may collect, retain and use any information that you provide.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Cookies and Web Beacons</strong></p>
    <p class="gray-text">
      We do use “cookies” to collect Website usage data and to improve your experience on the Website and our service
      generally. A “cookie” is a small data file transferred to your computer for access on future visits to the
      Website,
      which can tell us that you (or someone using the same computer or IP address) visited our Website(s) before,
      what
      clips you’ve listened to, etc. You can stop accepting cookies by setting your Internet browser accordingly, but
      this
      will likely result in our not recognizing you or your preferences on future visits, so you may have to re-enter
      certain information.
    </p>
    <p class="gray-text">
      The Website and e-mails from us may contain electronic images known as “web beacons.” These are files that allow
      us
      to count visitors to our Website, to tell if an ad has been viewed or if an e-mail has been opened or forwarded,
      or
      to serve particular content or services. Web beacons collect limited non-personal information, including beacon
      number, time and date of a page or e-mail view, and a description of the page on which the web beacon resides,
      all
      of which we may store and use. Disabling cookies may prevent some beacons’ activity, but generally the beacons
      will
      operate if you visit the Website or open e-mails from us.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Kinds of Cookies</strong>
    </p>
    <p class="gray-text">
      We may use the following categories:
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Strictly Necessary Cookies</strong>
    </p>
    <p class="gray-text">
      These cookies are essential in enabling you to browse our website and use its features. Without these cookies,
      services like checking out and electronic payments cannot be provided. For these types of cookies that are
      strictly
      required, no user consent is necessary.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Performance Cookies</strong></p>
    <p class="gray-text">
      These cookies collect anonymous information on how visitors use our website and whether they encounter error
      messages from our web pages. All information gathered is aggregated and therefore anonymized. They are only used
      to
      improve how a website works. By using our website, you agree that we can place these types of cookies on your
      device.
    </p>
  </div>
  <div class="mb-5">
    <p class="heading-color">
      <strong>Functionality Cookies</strong>
    </p>
    <p class="gray-text">
      These cookies allow our websites to remember choices you make while browsing, like language, font size, and user
      name preferences. We may also remember preferences such as text size, fonts and other customizable Website
      elements.
      They may also be used to enable you to watch videos or comment on a blog. The information these cookies collect
      will
      not personally identify you, and they cannot track your browsing activity outside our websites. When you choose
      these preferences, you agree that we can place these functional customization cookies on your device.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Advertising Cookies</strong>
    </p>
    <p class="gray-text">
      These cookies monitor traffic to ad-trackers. They are used by third-parties to serve ads and collect
      non-personal
      information when you visit our website for targeted advertising. Some of these companies use cookies to track
      information about your visits to our website and other websites in order to provide advertisements about goods
      and
      services that may interest you.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Opting Out</strong>
    </p>
    <p class="gray-text">
      You may opt out of having your information used for targeted advertising. When you opt out, an opt out cookie
      will
      be stored in your web browser. If you block or delete the opt out cookie, we will not be able to see your
      choice. If
      you change computers or web browsers, or use multiple computers or web browsers, you will need to complete the
      opt
      out procedure for each computer and each web browser.
    </p>
    <p class="gray-text">
      Opting out of targeted advertising means our website will not track your web preferences and usage patterns and
      will
      not use interest prediction technology to deliver ads. Opting-out does not mean you will not see any advertising
      on
      our website.
    </p>
    <p class="gray-text">
      You may opt out of targeted advertising by contacting us at:
      <a href="mailto:hello@djmixinglab.com">
        hello&#64;djmixinglab.com
      </a>
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Use of Information</strong>
    </p>
    <p class="gray-text">
      Our main use for the personal information we collect is to process your registration, purchases and payments,
      and to
      maintain your account on an ongoing basis. If you enter any contests, promotions, giveaways or other optional
      programs, we will use the information you provide to facilitate and communicate with you about that particular
      transaction, such as to notify you whether you’ve won, to deliver prizes. If you maintain a DJ profile page, we
      may
      use your personal information to communicate with you about that.
    </p>
    <p class="gray-text">
      We may also use your personal and non-personal information to enhance your experience with the Website and our
      service, such as sending you e-mails and otherwise providing you with other information, content and material in
      which we think you may be interested; displaying content and ads according to your prior browsing history,
      preferences and location; fulfilling your orders; providing customer service and responding to your questions
      and
      comments; or contacting you about your account or about our and and partners’ promotions, contests, surveys, or
      other promotions.
    </p>
    <p class="gray-text">
      We may use information learned from cookies and web beacons to make sure that our content and emails are in a
      format
      that you can read, to analyze trends about which Website, content and e-mails are popular and are being read
      and/or
      forwarded, to maintain a history of e-mail activity, and to evaluate the effectiveness and efficiency of certain
      communications.
    </p>
    <p class="gray-text">
      Your feedback and other information will also be used to evaluate and enhance our Website and service. For
      example,
      we may analyze the traffic and usage of our Website; the participation rate of our various promotions,
      offerings,
      e-mails, and other programs; and the popularity of our content, artists, and participating suppliers. We may
      also
      use that information for product development purposes, such as determining what other labels, artists, products
      and
      services our users are interested in, and for technical purposes such as monitoring the functionality of our
      servers
      and e-mail systems.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Sharing of Information</strong>
    </p>
    <p class="gray-text">
      We may share the information that we collect, both personal and non-personal, with third parties such as
      advertisers, contest sponsors, promotional and marketing partners, and the labels, artists and others who
      provide
      our content or whose products or services we think may interest you. We may also share it with our current and
      future affiliated companies and business partners, and if we are involved in a merger, asset sale or other
      business
      reorganization, we may also share or transfer your personal and non-personal information to our
      successors-in-interest.
    </p>
    <p class="gray-text">
      We may engage trusted third party service providers to perform functions and provide services to us, such as
      hosting
      and maintaining our servers and the Website, database storage and management, e-mail management, storage
      marketing,
      credit card processing, customer service and fulfilling orders for products and services you may purchase
      through
      the Website. We will likely share your personal information, and possibly some non-personal information, with
      these
      third parties to enable them to perform these services for us and for you.
    </p>

    <p class="gray-text">
      We may share portions of our log file data, including IP addresses, for analytics purposes with third parties
      such
      as web analytics partners, application developers, and ad networks. If your IP address is shared, it may be used
      to
      estimate general location and other technographics such as connection speed, whether you have visited the
      Website in
      a shared location, and type of the device used to visit the Website. They may aggregate information about our
      advertising and what you see on the Website and then provide auditing, research and reporting for us and our
      advertisers.
    </p>

    <p class="gray-text">
      We may also disclose personal and non-personal information about you to government or law enforcement officials
      or
      private parties as we, in our sole discretion, believe necessary or appropriate in order to respond to claims,
      legal
      process (including subpoenas), to protect our rights and interests or those of a third party, the safety of the
      public or any person, to prevent or stop any illegal, unethical, or legally actionable activity, or to otherwise
      comply with applicable court orders, laws, rules and regulations.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Security of Information</strong>
    </p>
    <p class="gray-text">
      We employ administrative, physical, and electronic measures designed to protect your information from
      unauthorized
      access. All credit transactions occur in a secure area of the Website using Secure Sockets Layer (SSL) software
      to
      process orders, which encrypts the information you input on the Website. For the storage and processing of
      credit
      card information, we engage a third party certified as compliant with the Payment Card Industry Data Security
      Standard (PCI DSS).
    </p>
    <p class="gray-text">
      In addition, all personal user information is stored behind a firewall with limited administrative access.
      However,
      please be aware that despite our best efforts, no security measures are perfect or impenetrable.
    </p>
    <p class="gray-text">
      Any information or material you may enter in publicly viewable portion of the Website, such as on an online
      forum or
      comment section, chat room, or bulletin board, will be readily accessible to the general public. Therefore, do
      not
      enter in those areas of the Website any personal information (e.g., your name, e-mail or postal address, credit
      card
      details) or other information or materials that you would not wish to be publicly available. This also applies
      to
      any communications you may have directly with other users of the Website.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Third-Party Links</strong>
    </p>
    <p class="gray-text">
      The Website may contain links to the websites associated with record labels, DJs, artists, and suppliers of
      content
      to the Website and to our advertisers, marketing partners, contest sponsors, or other third parties. Links,
      advertisements, promotions, or other mentions do not constitute our endorsement, authorization or representation
      of
      our affiliation with any third party, or of their products or services.
    </p>
    <p class="gray-text">
      Third party Website have their own privacy and data protection policies and practices, and may place their own
      cookies or other files on your computer, and collect or solicit both personally identifiable and non-personally
      identifiable information from you under rules different from this Policy. We do not control other Website,
      companies
      or persons and can’t be responsible for your experience once you leave our Website. Therefore, we strongly
      encourage
      you to carefully read the privacy policies, terms of use and other policies of other Website you visit.
    </p>
    <p class="gray-text">
      DISCLAIMER OF LIABILITY: There are third-party links on this webpage that
      will send you to websites that we have no control over. Clicking on a
      third-party link is done at your own discretion and risk. By clicking on a
      third-party link, you understand that you will be solely responsible for any
      loss or damage that may result from such activities.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>Children’s Information</strong>
    </p>
    <p class="gray-text">
      Our Website, products and and services are not intended for, and we do not
      knowingly accept registration or collect personally identifiable information
      from, engage in financial transactions with, or otherwise transact with,
      children under 13 years old. If we become aware that a child under 13 has
      provided us with personal identifiable Information, we will delete it from
      our files. If parents or legal guardians become aware that their under-13s
      have provided us with personally identifiable information without their
      consent (or that we have otherwise collected or obtained such information),
      they should contact us at
      <a href="mailto:hello@djmixinglab.com">
        hello&#64;djmixinglab.com
      </a>
    </p>
    <p class="gray-text">
      If you are between the ages of 13 and 18, or otherwise below the age of
      legal majority where you live, you must obtain permission from your parent
      or legal guardian before registering with one or more of the Website, using
      a credit card or providing any information about themselves to us or anyone
      else over the Internet.
    </p>
  </div>


  <div class="mb-5">
    <p class="heading-color">
      <strong>Storage of Information</strong>
    </p>
    <p class="gray-text">
      We collect, store and process the information we collect in the United
      States of America. If you are outside the U.S., then your personal and
      non-personal information may be transferred to the U.S.
    </p>
    <p class="gray-text">
      Nevada residents may request certain information regarding our disclosure of
      personal information to third parties for their direct marketing purposes,
      and those who have an established business relationship with us may also
      choose to opt-out from such disclosures. To do so, please contact us by one
      of the methods described below stating your specific request and your name,
      address, e-mail address and phone number. This will not prohibit disclosure
      of information for non-marketing purposes.
    </p>
    <p class="gray-text">
      E-mails that you receive from us will include specific instructions on how
      to unsubscribe from receiving certain communications. You may also send an
      email to us at
      <a href="mailto:hello@djmixinglab.com">
        hello&#64;djmixinglab.com
      </a>
      to update or correct the personal information we have on file for you or to
      be unsubscribed from marketing or promotional e-mailings.
    </p>
    <p class="gray-text">
      As long as you remain a registered user of one or more of the Website, or
      continue to make purchases or provide us with content, then we still reserve
      the right to contact you about your account and to inform you about
      operational matters regarding the Website.
    </p>
    <p class="gray-text">
      <strong>Contact Us</strong> <br>
      If you have any questions, concerns and suggestions about this document,
      please contact at:
      <a href="mailto:hello@djmixinglab.com">
        hello&#64;djmixinglab.com
      </a>
    </p>
  </div>
</div>
